export { CreateClassModals } from './component'
